const NotificationTypes = {
    AccessRequest: "AccessRequest",
    BusPartners: "BusPartners",
    BusPartnerSites: "BusPartnerSites",
    ContractLines: "ContractLines",
    CurrentAccounts: "CurrentAccounts",
    EquipmentEntries: "EquipmentEntries",
    InvoiceDocs: "InvoiceDocs",
    MovementFrom: "MovementFrom",
    OtherDocs: "OtherDocs",
    SalesCreditMemoLine: "SalesCreditMemoLine",
    SalesInvoiceLine: "SalesInvoiceLine",
    ServiceLine: "ServiceLine",
    TourLine: "TourLine",
    TransportDocs: "TransportDocs",
    DocAttachLog: "DocAttachLog",
    General: "General",
    NewsContent: "NewsContent",
    NewsLinks: "NewsLinks",
    NewsDocuments: "NewsDocuments"
}

export {
    NotificationTypes
}